// @spec VUL-STR-063
'use client';

import { createFileRoute } from '@tanstack/react-router';

import { NIS2ComplianceReportPage } from '@/features/vulnerabilities/pages/NIS2ComplianceReportPage';
import i18n from '@/lib/i18n';

export const Route = createFileRoute('/_authenticated/vulnerabilities/nis2-report')({
  beforeLoad: () => ({
    getTitle: () => i18n.t('routeTitles.nis2ComplianceReport'),
  }),
  component: NIS2ComplianceReportPage,
});
